import React, { useState, useEffect } from "react";
import { Table } from "antd";
import {
  User1,
  User2,
  User3,
  User4,
  User5,
  User6,
  User7,
  User8,
  User9,
  User10,
  User11,
  User12,
} from "../../../../Routes/ImagePath";
import { Link } from "react-router-dom";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";

import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

import AuthUser from "../../../../components/AuthUser";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "../../../../components/Spinner";
import CursoModal from "../../../../components/Administration/employees/CursoModal";
import CursoEditModal from "../../../../components/Administration/employees/CursoEditModal";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const CursoTable = ({ cursos, tipo }) => {
  const { t } = useTranslation();

  const [curso, setcurso] = useState();
  const [cursoselecionado, setcursoSelecionado] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const { http, url_root, user_permissoes, verificarPermissao, getMissao } = AuthUser();

  // State to track whether the "checkgeral" checkbox is checked
  const [loading, setLoading] = useState(false);

  const [selectedUserIds, setSelectedUserIds] = useState([]);

  useEffect(() => {
    setcurso(cursos);
  }, [cursos]);

  const handleSubmissionSuccess = (cursos) => {
    setcurso(cursos);
  };

  const chamarModalEliminar = (idSelecionado) => {
    setcursoSelecionado(idSelecionado);
    const editButton = document.getElementById("triggerModalEliminar");
    if (editButton) {
      editButton.click();
    }
  };

  const chamarModalEdit = (idSelecionado) => {
    setcursoSelecionado(idSelecionado);
    const editButton = document.getElementById("triggerModalEdit");
    if (editButton) {
      editButton.click();
    }
  };

  const handleAtivarDesativar = async (id, newState) => {
    if (verificarPermissao("CARGO", "ativar")) {
      try {
        setLoading(true);

        const formData = new FormData();
        formData.append("id", id);
        formData.append("estado", newState == 1 ? 1 : 0);

        const response = await http.post(
          "/curso-ativate-desactivate-single",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        setLoading(false);
        setcurso(response.data.cursos);
      } catch (error) {
        console.error(error);

        setLoading(false);

        toast.error(
          "Ocorreu um erro ao atualizar o estado do usuário. Por favor, tente novamente mais tarde.",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      } finally {
        setLoading(false);
      }
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (text, record, index) => index + 1,
    },
    {
      title: t("Sigla"),
      dataIndex: "sigla",
      render: (text, record) => (
        <div className="table-avatar">
          <Link to="#" className="avatar">
            <img
              src={url_root + "/storage/cursos/" + record.imagem}
              alt="logo"
            />
          </Link>
          <Link to="#">{record?.sigla}</Link>
        </div>
      ),
      sorter: (a, b) => a.sigla.length - b.sigla.length,
    },
    {
      title: "Designação",
      dataIndex: "designacao",
      sorter: (a, b) => a.designacao.length - b.designacao.length,
    },
    {
      title: "Nivel",
      dataIndex: "nivel",
      render: (text, record) => (
        <>
          <span title={record?.nivel}>
            {record.nivel == 1
              ? "Básico"
              : record.nivel == 2
              ? "Intermédio"
              : record.nivel == 3
              ? "Avançado"
              : "Padrão"}
          </span>
        </>
      ),
      sorter: (a, b) => a.nivel.length - b.nivel.length,
    },
    {
      title: "Validade",
      dataIndex: "duracao",
      render: (text, record) => (
        <>
          <span title={record?.expira}>
            {record.expira == 1
              ? record.expiracao +
                " " +
                (record.expira_unidade == 1 ? "Meses" : "Ano(s)")
              : "Não expira"}
          </span>
        </>
      ),
      sorter: (a, b) => a.duracao.length - b.duracao.length,
    },
    {
      title: t("Status"),
      dataIndex: "estado",
      render: (text, record) => (
        <>
          <span
            className={
              record?.estado == 1
                ? "badge bg-inverse-success"
                : "badge bg-inverse-danger"
            }
          >
            {record?.estado == 1 ? "Ativo" : "Desativado"}
          </span>
          &nbsp;
          <span
            onClick={() => handleAtivarDesativar(record.id, text == 1 ? 0 : 1)}
          >
            <i className="fa fa-recycle"></i>
          </span>
        </>
      ),
      sorter: (a, b) => a.estado.length - b.estado.length,
    },

    {
      title: t("Action"),
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <span
              className="dropdown-item"
              title={record?.sigla}
              onClick={() => chamarModalEdit(record)}
            >
              <i className="fa fa-pencil m-r-5" /> {t("Edit")}
            </span>
            <span
              className="dropdown-item"
              title={record?.sigla}
              onClick={() => chamarModalEliminar(record)}
            >
              <i className="fa fa-trash m-r-5" /> {t("Delete")}
            </span>
          </div>
        </div>
      ),
    },
  ];

  const handleExportarCursosPDF = async (cursos, url_root, getMissao) => {
    const doc = new jsPDF();

    // Define o conteúdo da tabela
    const columns = [
      { header: "Sigla", dataKey: "sigla" },
      { header: "Designação", dataKey: "designacao" },
      { header: "Nível", dataKey: "nivel" },
      { header: "Validade", dataKey: "validade" },
      { header: "Estado", dataKey: "estado" },
    ];

    const data = cursos.map((curso) => ({
      sigla: curso.sigla || "",
      designacao: curso.designacao || "",
      nivel:
        curso.nivel === 1
          ? "Básico"
          : curso.nivel === 2
          ? "Intermédio"
          : curso.nivel === 3
          ? "Avançado"
          : "Padrão",
      validade:
        curso.expira === 1
          ? `${curso.expiracao} ${
              curso.expira_unidade === 1 ? "Meses" : "Ano(s)"
            }`
          : "Não expira",
      estado: curso.estado === 1 ? "Ativo" : "Desativado",
    }));

    // Define a função para desenhar o conteúdo
    const renderPDFContent = (startY) => {
      doc.setFontSize(14);
      doc.text("Lista de Cursos", 105, startY, { align: "center" });
      doc.setLineWidth(0.5);
      doc.line(10, startY + 5, 200, startY + 5);

      autoTable(doc, {
        head: [columns.map((col) => col.header)],
        body: data.map((row) => columns.map((col) => row[col.dataKey])),
        startY: startY + 10,
        styles: { fontSize: 10 },
      });

      doc.save("cursos.pdf");
    };

    // Tenta carregar o logotipo
    try {
      const imageUrl = `${url_root}/storage/${getMissao()?.imagem}`;
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      const reader = new FileReader();
      reader.onloadend = function () {
        const base64data = reader.result;
        doc.addImage(base64data, "JPEG", 10, 10, 30, 20);
        renderPDFContent(38); // com logo
      };
      reader.readAsDataURL(blob);
    } catch (error) {
      console.warn("Erro ao carregar imagem. Exportando sem logotipo.");
      renderPDFContent(20); // sem logo
    }
  };

  if (loading)
    return (
      <>
        <Spinner>
          <ToastContainer />
        </Spinner>
      </>
    );
  else
    return (
      <>
        <div className="row">
          <div className="col-md-12">

             <button
              className="btn btn-danger mb-3"
             onClick={() => handleExportarCursosPDF(curso, url_root, getMissao)}
            >
              <i className="fa fa-file-pdf" /> Exportar PDF
            </button>


            <div className="table-responsive">
              <Table
                className="table-striped"
                style={{ overflowX: "auto" }}
                columns={columns}
                dataSource={curso}
                rowKey={(record) => record.id}
              />
              <CursoModal
                onSubmissionSuccess={handleSubmissionSuccess}
                curso={cursoselecionado}
                imagePreview={cursoselecionado?.logo}
                tipo={tipo}
              />

              <CursoEditModal
                onSubmissionSuccess={handleSubmissionSuccess}
                curso={cursoselecionado}
              />

              <DeleteModal
                objectoName={t("Registo")}
                onSubmissionSuccess={handleSubmissionSuccess}
                id={cursoselecionado?.id}
                endpoint={"curso"}
              />

              <span
                data-bs-toggle="modal"
                data-bs-target="#edit_curso_modal"
                id="triggerModalEdit"
              ></span>

              <span
                data-bs-toggle="modal"
                data-bs-target="#delete"
                id="triggerModalEliminar"
              ></span>
            </div>
          </div>
        </div>
        <ToastContainer />
      </>
    );
};

export default CursoTable;
